import { render, staticRenderFns } from "./TEXTDISPLAY.vue?vue&type=template&id=7a3b69c0&scoped=true&"
import script from "./TEXTDISPLAY.vue?vue&type=script&lang=js&"
export * from "./TEXTDISPLAY.vue?vue&type=script&lang=js&"
import style0 from "./TEXTDISPLAY.vue?vue&type=style&index=0&id=7a3b69c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3b69c0",
  null
  
)

export default component.exports